/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChangeSetCategory = {
    Unit: 'Unit',
    EnumerationQuantity: 'EnumerationQuantity',
    EnumerationOptionSetups: 'EnumerationOptionSetups',
    MedicalSystemScopeSetup: 'MedicalSystemScopeSetup',
    QaEquipmentScopeSetup: 'QaEquipmentScopeSetup',
    EnumerationOptionEvaluations: 'EnumerationOptionEvaluations',
    MedicalSystemScopeEvaluation: 'MedicalSystemScopeEvaluation',
    QaEquipmentScopeEvaluation: 'QaEquipmentScopeEvaluation',
    UseInEvaluations: 'UseInEvaluations',
    UseInSetups: 'UseInSetups',
    User: 'User',
    Quantity: 'Quantity',
    GeometryUseInSetup: 'GeometryUseInSetup',
    GeometryUseInEvaluation: 'GeometryUseInEvaluation',
    Protocol: 'Protocol',
    Roles: 'Roles',
    Attachments: 'Attachments',
    EvaluationQuantity: 'EvaluationQuantity',
    Definition: 'Definition',
    DefinitionParameters: 'DefinitionParameters',
    Permissions: 'Permissions'
} as const;
export type ChangeSetCategory = typeof ChangeSetCategory[keyof typeof ChangeSetCategory];


export function ChangeSetCategoryFromJSON(json: any): ChangeSetCategory {
    return ChangeSetCategoryFromJSONTyped(json, false);
}

export function ChangeSetCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeSetCategory {
    return json as ChangeSetCategory;
}

export function ChangeSetCategoryToJSON(value?: ChangeSetCategory | null): any {
    return value as any;
}

/**
 * Check if a given object implements the ChangeSetCategory interface.
 */
 export function instanceOfChangeSetCategory(value: any): value is ChangeSetCategory {
    return Object.values(ChangeSetCategory).includes(value)
}

